export const displayCustomInterval = (trigger, excludeTriggerType = "", eventInterval = 7200) => {
  if (
    trigger?.custom_trigger_id &&
    (!excludeTriggerType || trigger.trigger_type !== excludeTriggerType)
  ) {
    if (trigger.custom_trigger_seconds === eventInterval) return "Event";
    return trigger.custom_trigger_seconds;
  }
  return null;
};

export const regexDisplay = trigger => {
  if (["web", "device"].includes(trigger?.trigger_type)) {
    return trigger.use_regex ? "Yes" : "No";
  }
  return "N/A";
};

const FILTER_OPTION_LABELS = {
  url_host: "Domain name",
  url_path: "Page URL Path",
  query_params: "Query Parameters",
  url_hash: "URL Hash",
};

const formatFilterOptions = filterOptions =>
  Object.entries(FILTER_OPTION_LABELS).reduce((acc, [key, label]) => {
    const rules = filterOptions[key];
    if (!rules?.length) return acc;
    const group = rules
      .map(({ match_type, values }) => `${label}(${match_type}): ${(values ?? []).join(", ")}`)
      .join("\n");
    return acc ? `${acc}\n${group}` : group;
  }, "") || "All pages";

export const displayPage = trigger => {
  if (trigger?.filter_options?.enabled) {
    return formatFilterOptions(trigger.filter_options);
  }
  let page = trigger?.url_path || "";
  [trigger?.url_host, trigger?.query_params, trigger?.url_hash].forEach(el => {
    if (el) {
      if (page) page += "; ";
      page += el;
    }
  });
  return page;
};

export const displayCustomTrigger = (trigger, customTriggers, excludeTriggerType = "") => {
  if (
    trigger &&
    customTriggers &&
    (!excludeTriggerType || trigger.trigger_type !== excludeTriggerType)
  ) {
    const custom = customTriggers.find(({ id }) => id === trigger.custom_trigger_id);
    if (custom) return custom.name;
  }
  return null;
};
